module.exports = __webpack_public_path__ + "static/media/profile-manage-rev-red.5930583d.svg";